import { LogoutButton } from '@features/authentication/components';
import { LanguageSwitcher } from '@features/language';
import { useSelectedProductionSelectors } from '@features/productions';
import {
    ChevronRightIcon,
    MagnifyingGlassIcon,
    PersonIcon,
} from '@radix-ui/react-icons';
import {
    DropdownMenu,
    Flex,
    IconButton,
    // Separator,
    Text,
} from '@radix-ui/themes';
import {
    AdvancedSearchPagePath,
    HomePagePath,
    // OperationsPagePath,
    ProductionsSelectionPagePath,
} from '@router/constants';
import BrandLogo from '../Brand/BrandLogo';
import { AppLink } from '../Link/AppLink';
import { PermissionCheck, ProtectionLevel } from '@router';
// import { useTranslation } from 'react-i18next';
// import { NavigationTabs } from '../NavigationTabs/NavigationTabs';
// import { NavigationTab } from '../NavigationTabs/NavigationTab';

import styles from './Header.module.css';

export const Header = () => {
    // const { t } = useTranslation();
    const { selectedProduction } = useSelectedProductionSelectors();

    return (
        <Flex className={styles.header} gap={'5'} align='center'>
            <AppLink className={styles.link} to={HomePagePath}>
                <BrandLogo />
            </AppLink>

            <PermissionCheck
                level={
                    ProtectionLevel.AUTHENTICATED |
                    ProtectionLevel.PRODUCTION_SELECTED
                }
            >
                <Flex align={'center'} flexGrow={'1'} gap={'2'}>
                    <AppLink
                        className={styles.link}
                        to={ProductionsSelectionPagePath}
                    >
                        <Text
                            size={'3'}
                            weight={'regular'}
                            wrap={'nowrap'}
                            color={'gray'}
                            highContrast
                        >
                            <Flex gap={'0'} flexShrink={'0'} align={'center'}>
                                {selectedProduction?.name}
                                <ChevronRightIcon
                                    width={'16px'}
                                    height={'16px'}
                                />
                            </Flex>
                        </Text>
                    </AppLink>

                    {/* <Separator orientation={'vertical'} size={'2'} mx={'3'} /> */}

                    {/* <NavigationTabs
                        options={[
                            {
                                label: t('pages.home'),
                                value: 'home',
                                href: HomePagePath,
                            },
                            {
                                label: t('pages.operations'),
                                value: 'operations',
                                href: OperationsPagePath,
                            },
                        ]}
                    >
                        <NavigationTab />
                    </NavigationTabs> */}
                </Flex>
            </PermissionCheck>

            <PermissionCheck
                level={
                    ProtectionLevel.AUTHENTICATED |
                    ProtectionLevel.PRODUCTION_SELECTED
                }
            >
                <IconButton
                    className={styles.settings}
                    variant={'ghost'}
                    radius={'full'}
                    style={{ color: 'inherit' }}
                    asChild
                >
                    <AppLink
                        className={styles.link}
                        to={AdvancedSearchPagePath}
                    >
                        <MagnifyingGlassIcon height={'20px'} width={'20px'} />
                    </AppLink>
                </IconButton>
            </PermissionCheck>

            <DropdownMenu.Root>
                <DropdownMenu.Trigger>
                    <IconButton
                        className={styles.settings}
                        variant={'ghost'}
                        radius={'full'}
                        color={'gray'}
                        highContrast
                        asChild
                    >
                        <PersonIcon height={'20px'} width={'20px'} />
                    </IconButton>
                </DropdownMenu.Trigger>

                <DropdownMenu.Content>
                    <Flex direction={'column'}>
                        <LanguageSwitcher />
                        <PermissionCheck level={ProtectionLevel.AUTHENTICATED}>
                            <DropdownMenu.Separator />
                            <LogoutButton />
                        </PermissionCheck>
                    </Flex>
                </DropdownMenu.Content>
            </DropdownMenu.Root>
        </Flex>
    );
};

export default Header;
